import React from "react";
import PropTypes from 'prop-types';
import * as d3 from "d3";
import numeral from "numeral";
import Axes from './Axes.jsx';
import Bars from './Bars.jsx';
import BarsChart from './BarsChart.jsx';
import GroupColumns from './GroupColumns.js';
import GroupBars from './GroupBars.js';
import StackColumns from './StackColumns.js';
import StackBars from './StackBars.js';
import AreaChart from './AreaChart.jsx';
import ProcessBarChart from './ProcessBarChart.jsx';
import VerticalAreaChart from './VerticalAreaChart.jsx';
import LineChart from './LineChart.jsx';
import VerticalLineChart from './VerticalLineChart.jsx';
import BollingerBands from './BollingerBands.jsx';
import legend from "./Legend.js";
import tooltip from "./Tooltip.js";
import utils from "./utils.js";
import "./MultiSeriesChart.css";
import { Portal } from 'react-portal';
import ScaleUtils from "../../ScaleUtils.js";

const customFormat = (value, format, index) => {
  if(typeof format === 'string'){
    return numeral(value).format(format)
  } else if (typeof format === 'function') {
    return format(value, index)
  }else{
    return value;
  }
}


export default class MultiSeriesChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = $.extend(
      true,
      {
        g: null,
        xAxisScale:null,
        xAxis:"",
        y0Axis:"",
        y1Axis:"",
        y0Axisg:"",
        y1Axisg:"",
        xAxisg:"",
        yAxis0Scale:null,
        yAxis1Scale:null,
        stackBarChildComponent:null,
        lineChartChildComponent:null,
        areaChartChildComponent:null,
        columnChartChildComponent:null,
        columnGroupChartChildComponent:null,
        stackBarOffset:{x:0,y:0,tooltipStyle:{}},
        lineChartOffset:{x:0,y:0,id:'',tooltipStyle:{}},
        areaChartOffset:{x:0,y:0,id:'',tooltipStyle:{}},
        columnChartOffset:{x:0,y:0,id:'',tooltipStyle:{}},
        columnGroupChartOffset:{x:0,y:0,id:'',tooltipStyle:{}},
        disabledSeriesIndex: this.getDisabledLegends(props)
      },
      props
    );
  }

  getDisabledLegends(data) {
    if(!(data.config && data.config.legend)){
      return [];
    }
    if(data.config && typeof data.config.onLegendClick === 'function') {
      let legendData = Array.isArray(data.config.legend)==false ?  [data.config.legend] : data.config.legend;
      let disabledIndexes = legendData.map((d,i)=> d.isSeriesDisabled === true ? i : -1)
      let filteredIndexes = disabledIndexes.filter(f=>f!=-1);
      return disabledIndexes;
    } else {
      return this.state ? this.state.disabledSeriesIndex : [];
    }
  }

  componentDidMount() {
    this.renderColorLegend();
    this.chartTitle && d3.select(this.chartTitle).attr("y",d3.select(this.chartTitle).node().getBBox().height);
    this.chartSubTitle && d3.select(this.chartSubTitle).attr("y",(this.chartTitle!=null ? d3.select(this.chartTitle).node().getBBox().height : 0)+d3.select(this.chartSubTitle).node().getBBox().height+2);
  }

  componentWillUnmount(){
    hideDetail();
  }

  componentWillReceiveProps(nextProps){
    if(this.getDisabledLegends(nextProps).join() !== this.state.disabledSeriesIndex.join()) {
      this.setState({
        disabledSeriesIndex: this.getDisabledLegends(nextProps)
      })
    }
    mountScrollDownEvent();
  }

  componentDidUpdate(nextProps) {
    this.renderColorLegend();
  }

  onLegendClick=(currentSelected,index)=>{
    var disabledSeriesIndex=this.state.disabledSeriesIndex;
    if(disabledSeriesIndex.indexOf(index)==-1){
      disabledSeriesIndex.push(index);
    }else{
        for( var i =0;i< disabledSeriesIndex.length; i++){
          if (disabledSeriesIndex[i] === index) disabledSeriesIndex.splice(i, 1);
        }
    }
    if (
      this.props.config.onLegendClick &&
      typeof this.props.config.onLegendClick === "function"
    ) {
      this.props.config.onLegendClick(disabledSeriesIndex);
    } else {
      this.setState({
        disabledSeriesIndex:disabledSeriesIndex
      });
    }
  }

  renderColorLegend=()=>{
    var chartConfig=this.state.config;
    var chartLegendData=[];
    var that=this;
    d3.selectAll(".ReactD3MultiSeriesChart_"+(this.props.id || '')+" .multiSeriesLegend").remove();
    //CBT:create Color Legend start here
    if (chartConfig.hasOwnProperty("legend")) {
      if(Array.isArray(this.props.config.legend)==false){
        chartLegendData=$.extend({},false,this.props.config.legend);
        chartLegendData=[chartLegendData];
      }else{
        this.props.config.legend.forEach(function(d){
          chartLegendData.push($.extend({},false,d));
        })
      } 
      var lastLegendElements=0;
      chartLegendData.forEach(function(chartLegend,legendIndex){
        // var chartLegend=$.extend({},false,this.props.config.legend);
        var legendClass="colorLegendMainG_"+legendIndex+"_"+that.props.id;
        d3.selectAll(".ReactD3MultiSeriesChart_"+(that.props.id || '')+" ."+legendClass).remove();
        chartLegend["mainSvgId"] ="ReactD3MultiSeriesChart_"+(that.props.id || '');
        chartLegend["mainSvgWidth"] = chartConfig.width;
        chartLegend["mainSvgHeight"] = chartConfig.height;
        chartLegend["legendClass"] = legendClass;
        chartLegend["lastLegendElements"]=lastLegendElements;
        chartLegend["disabledSeriesIndex"] = that.state.disabledSeriesIndex
        chartLegend["range"]=chartLegend["range"].map(function(d,index){
          if(that.state.disabledSeriesIndex.indexOf(index+lastLegendElements)!=-1){
            d="#AAA";
          }
          return d;
        });
        
        if(chartLegend["enableLegendClick"]==undefined || chartLegend["enableLegendClick"]==true){
          chartLegend["enableLegendClick"]={
            onLegendClick:that.onLegendClick
          }
        }
        legend.createColorLegend(chartLegend);
        lastLegendElements=lastLegendElements+chartLegend["labels"].length;
      })

    } 
    // else {
    //   d3.selectAll(".ReactD3MultiSeriesChart_"+(this.props.id || '')+" .multiSeriesLegend").remove();
    // }
    //CBT:create Color Legend end here
  }
  hideStackBarTooltip=()=>{
    d3.selectAll(".multiserie-component-custom-tooltip").remove();
    this.setState({
      stackBarChildComponent:null,
      stackBarOffset:{x:0,y:0}
    })
  }
  hideLineChartTooltip=()=>{
    d3.selectAll(".multiserie-component-custom-tooltip").remove();
    this.setState({
      lineChartChildComponent:null,
      lineChartOffset:{x:0,y:0,id:''}
    })
  }
  hideAreaChartTooltip=()=>{
    d3.selectAll(".multiserie-component-custom-tooltip").remove();
    this.setState({
      areaChartChildComponent:null,
      areaChartOffset:{x:0,y:0,id:''}
    })
  }
  hideColumnChartTooltip=()=>{
    d3.selectAll(".multiserie-component-custom-tooltip").remove();
    this.setState({
      columnChartChildComponent:null,
      columnChartOffset:{x:0,y:0,id:''}
    })
  }
  hideColumnGroupChartTooltip=()=>{
    d3.selectAll(".multiserie-component-custom-tooltip").remove();
    this.setState({
      columnGroupChartChildComponent:null,
      columnGroupChartOffset:{x:0,y:0,id:''}
    })
  }
  showStackBarTooltip=(component,mouseEvent)=>{
    this.setState({
      stackBarChildComponent:component,
      stackBarOffset:mouseEvent
    })
  }
  showLineChartTooltip=(component,mouseEvent)=>{
    this.setState({
      lineChartChildComponent:component,
      lineChartOffset:mouseEvent
    })
  }
  showAreaChartTooltip=(component,mouseEvent)=>{
    this.setState({
      areaChartChildComponent:component,
      areaChartOffset:mouseEvent
    })
  }
  showColumnChartTooltip=(component,mouseEvent)=>{
    this.setState({
      columnChartChildComponent:component,
      columnChartOffset:mouseEvent
    })
  }
  showColumnGroupChartTooltip=(component,mouseEvent)=>{
    this.setState({
      columnGroupChartChildComponent:component,
      columnGroupChartOffset:mouseEvent
    })
  }
  // renderMultiSeriesChart(nextProps) {

  // }
  renderSTackBarToolTipComponent=()=>{
    var width=document.body.clientWidth;
    var height=document.body.clientHeight;
    var innerWidth=this.state.stackBarChildComponent.props.config.width;
    var innerHeight=this.state.stackBarChildComponent.props.config.height;
    var tooltipStyle=this.state.stackBarOffset.tooltipStyle || {};
    var parentDiv=this.props.id;
    var translateX=0;
    var translateY=0;
    var y=this.state.stackBarOffset.y;
    var x=this.state.stackBarOffset.x;
    var bandwidth=parseFloat(this.state.stackBarOffset.bandwidth);
    var barHeight=parseFloat(this.state.stackBarOffset.barHeight);
    var triangleHeight=15;
    var triangleWidth=10;
    var x1=0,x2=0,x3=0,y1=0,y2=0,y3=0;
    var parentSelector=$("#"+parentDiv).offset();
    var divX=translateX;
     if(x+innerWidth+triangleWidth+bandwidth+parentSelector.left < (width)  ){//&& y-innerHeight-triangleHeight>0
      //CBT:show on right
      translateX=x+bandwidth+triangleWidth;
      translateY=y+(barHeight/2)-(innerHeight/2);
      x1=-triangleWidth;
      y1=(innerHeight/2);
      x2=x1+triangleWidth+1;
      y2=y1-(triangleHeight/2)-2;
      x3=x1+triangleWidth+1;
      y3=y1+(triangleHeight/2)+2;
      divX=translateX;
    }else if((x+parentSelector.left)-innerWidth>0 ) {//&& y-innerHeight-triangleHeight>0
      //CBT:show on left
      translateX=x-innerWidth-triangleWidth;
      translateY=y+(barHeight/2)-(innerHeight/2);
      x1=innerWidth+triangleWidth;
      y1=(innerHeight/2);
      x2=x1-triangleWidth-1;
      y2=y1-(triangleHeight/2)-4;
      x3=x1-triangleWidth-1;
      y3=y1+(triangleHeight/2)+4;
      divX=translateX-3;
    }
    // else if(y-innerHeight-triangleHeight>0){
    //   //CBT:show on top
    //   translateX=x+(bandwidth/2)-(innerWidth/2);
    //   translateY=y-innerHeight-triangleHeight;
    //   x1=innerWidth/2
    //   y1=innerHeight+triangleHeight;
    //   x2=x1-(triangleWidth/2)-4;
    //   y2=y1-triangleHeight;
    //   x3=x1+(triangleWidth/2)+4;;
    //   y3=y1-triangleHeight;
    // }else if(y+innerHeight+triangleHeight<height){
    //   //CBT:show on bottom
    //   translateX=x+(bandwidth/2)-(innerWidth/2);
    //   translateY=y+barHeight+triangleHeight;
    //   x1=innerWidth/2
    //   y1=0-triangleHeight;
    //   x2=x1-(triangleWidth/2)-4;
    //   y2=y1+triangleHeight;
    //   x3=x1+(triangleWidth/2)+4;;
    //   y3=y1+triangleHeight;
    // }
    //CBT:if inner bar height greater that screen hight then reduce it
    var divY=translateY+parentSelector.top;
    if(divY+innerHeight>(height*0.9)){
      var differenceHeight=(divY+innerHeight)-height;
      divY=divY-differenceHeight-75;
    }
    var element=document.createElement("div");
    document.body.appendChild(element);
    element.setAttribute("class",'multiserie-component-custom-tooltip');
    element.setAttribute("style",utils.convertReactStyleToHtml(tooltipStyle,"border: 2px solid;border-color: #ddd;border-radius: 4px;position:fixed;top:"+(divY)+"px;left:"+(divX+parentSelector.left)+"px;background-color:#000;"));
    var key='key_'+Math.random();
    key=key.split('.').join("_");
    return (
      <g transform={"translate("+translateX+","+translateY+")"} key={key} className='multiserie-component-custom-tooltip'>
      <Portal node={element}>{this.createInnerChildElement(this.state.stackBarChildComponent,this.hideStackBarTooltip,this,this.state.stackBarOffset.isDataTip)}</Portal>
      <polygon points={x1+","+y1+" "+x2+","+y2+" "+x3+","+y3} style={{fill:tooltipStyle.fill || "rgba(255,255,255,0.9)",fillOpacity:tooltipStyle.fillOpacity || "0.9",stroke:tooltipStyle.stroke || "#ccc"}}  />
      </g>
    )
  }

  renderLineChartToolTipComponent=()=>{
    var width=document.body.clientWidth;
    var height=document.body.clientHeight;
    var innerWidth=this.state.lineChartChildComponent.props.config.width;
    var innerHeight=this.state.lineChartChildComponent.props.config.height;
    var tooltipStyle=this.state.lineChartOffset.tooltipStyle || {};
    var parentDiv=this.props.id;
    var translateX=0;
    var translateY=0;
    var y=this.state.lineChartOffset.y;
    var x=this.state.lineChartOffset.x;
    var bandwidth=parseFloat(this.state.lineChartOffset.radius);
    var barHeight=parseFloat(this.state.lineChartOffset.radius);
    var triangleHeight=15;
    var triangleWidth=10;
    var x1=0,x2=0,x3=0,y1=0,y2=0,y3=0;
    var parentSelector=$("#"+parentDiv).offset();
    var divX=translateX;
     if(x+innerWidth+parentSelector.left<width ){//&& y-innerHeight-triangleHeight>0
      //CBT:show on right
      translateX=x+bandwidth+triangleWidth;
      translateY=y+(barHeight/2)-(innerHeight/2);
      x1=-triangleWidth;
      y1=(innerHeight/2);
      x2=x1+triangleWidth+1;
      y2=y1-(triangleHeight/2)-2;
      x3=x1+triangleWidth+1;
      y3=y1+(triangleHeight/2)+2;
      divX=translateX;
    }else if((x+parentSelector.left)-innerWidth>0 ) {//&& y-innerHeight-triangleHeight>0
      //CBT:show on left
      translateX=x-innerWidth-triangleHeight-bandwidth;
      translateY=y+(barHeight/2)-(innerHeight/2);
      x1=innerWidth+triangleWidth;
      y1=(innerHeight/2);
      x2=x1-triangleWidth-1;
      y2=y1-(triangleHeight/2)-4;
      x3=x1-triangleWidth-1;
      y3=y1+(triangleHeight/2)+4;
      divX=translateX-3;
    }else if(y-innerHeight-triangleHeight>0){
      //CBT:show on top
      translateX=x-(innerWidth/2);
      translateY=y-innerHeight-triangleHeight;
      x1=innerWidth/2
      y1=innerHeight+triangleHeight;
      x2=x1-(triangleWidth/2)-4;
      y2=y1-triangleHeight;
      x3=x1+(triangleWidth/2)+4;;
      y3=y1-triangleHeight;
    }else if(y+innerHeight+triangleHeight<height){
      //CBT:show on bottom
      translateX=x-(innerWidth/2);
      translateY=y+barHeight+triangleHeight;
      x1=innerWidth/2
      y1=0-triangleHeight;
      x2=x1-(triangleWidth/2)-4;
      y2=y1+triangleHeight;
      x3=x1+(triangleWidth/2)+4;;
      y3=y1+triangleHeight;
    }
    //CBT:if inner bar height greater that screen hight then reduce it
    var divY=translateY+parentSelector.top;
    if(divY+innerHeight>(height*0.9)){
      var differenceHeight=(divY+innerHeight)-height;
      divY=divY-differenceHeight-75;
    }
   var element=document.createElement("div");
   document.body.appendChild(element);
   element.setAttribute("class",'multiserie-component-custom-tooltip');
   element.setAttribute("style",utils.convertReactStyleToHtml(tooltipStyle,"border: 2px solid;border-color: #ddd;border-radius: 4px;position:fixed;top:"+(divY)+"px;left:"+(divX+parentSelector.left)+"px;background-color:#000;"));
   var key='key_'+Math.random();
   key=key.split('.').join("_");
   return (
     <g transform={"translate("+translateX+","+translateY+")"} key={key} className='multiserie-component-custom-tooltip'>
     <Portal node={element}>{this.createInnerChildElement(this.state.lineChartChildComponent,this.hideLineChartTooltip,this,this.state.lineChartOffset.isDataTip)}</Portal>
     <polygon  points={x1+","+y1+" "+x2+","+y2+" "+x3+","+y3} style={{fill:tooltipStyle.fill || "rgba(255,255,255,0.9)",fillOpacity:tooltipStyle.fillOpacity || "0.9",stroke:tooltipStyle.stroke || "#ccc"}}   />
     </g>
   )
  }
  renderAreaChartToolTipComponent=()=>{
    var width=document.body.clientWidth;
    var height=document.body.clientHeight;
    var innerWidth=this.state.areaChartChildComponent.props.config.width;
    var innerHeight=this.state.areaChartChildComponent.props.config.height;
    var tooltipStyle=this.state.areaChartOffset.tooltipStyle || {};
    var parentDiv=this.props.id;
    var translateX=0;
    var translateY=0;
    var y=this.state.areaChartOffset.y;
    var x=this.state.areaChartOffset.x;
    var bandwidth=parseFloat(this.state.areaChartOffset.radius);
    var barHeight=parseFloat(this.state.areaChartOffset.radius);
    var triangleHeight=15;
    var triangleWidth=10;
    var x1=0,x2=0,x3=0,y1=0,y2=0,y3=0;
    var parentSelector=$("#"+parentDiv).offset();
    var divX=translateX;
     if(x+innerWidth+parentSelector.left<width ){//&& y-innerHeight-triangleHeight>0
      //CBT:show on right
      translateX=x+bandwidth+triangleWidth;
      translateY=y+(barHeight/2)-(innerHeight/2);
      x1=-triangleWidth;
      y1=(innerHeight/2);
      x2=x1+triangleWidth+1;
      y2=y1-(triangleHeight/2)-2;
      x3=x1+triangleWidth+1;
      y3=y1+(triangleHeight/2)+2;
      divX=translateX;
    }else if((x+parentSelector.left)-innerWidth>0 ) {//&& y-innerHeight-triangleHeight>0
      //CBT:show on left
      translateX=x-innerWidth-triangleHeight-bandwidth;
      translateY=y+(barHeight/2)-(innerHeight/2);
      x1=innerWidth+triangleWidth;
      y1=(innerHeight/2);
      x2=x1-triangleWidth-1;
      y2=y1-(triangleHeight/2)-4;
      x3=x1-triangleWidth-1;
      y3=y1+(triangleHeight/2)+4;
      divX=translateX-3;
    }else if(y-innerHeight-triangleHeight>0){
      //CBT:show on top
      translateX=x-(innerWidth/2);
      translateY=y-innerHeight-triangleHeight;
      x1=innerWidth/2
      y1=innerHeight+triangleHeight;
      x2=x1-(triangleWidth/2)-4;
      y2=y1-triangleHeight;
      x3=x1+(triangleWidth/2)+4;;
      y3=y1-triangleHeight;
    }else if(y+innerHeight+triangleHeight<height){
      //CBT:show on bottom
      translateX=x-(innerWidth/2);
      translateY=y+barHeight+triangleHeight;
      x1=innerWidth/2
      y1=0-triangleHeight;
      x2=x1-(triangleWidth/2)-4;
      y2=y1+triangleHeight;
      x3=x1+(triangleWidth/2)+4;;
      y3=y1+triangleHeight;
    }
    //CBT:if inner bar height greater that screen hight then reduce it
    var divY=translateY+parentSelector.top;
    if(divY+innerHeight>(height*0.9)){
      var differenceHeight=(divY+innerHeight)-height;
      divY=divY-differenceHeight-75;
    }
   var element=document.createElement("div");
   document.body.appendChild(element);
   element.setAttribute("class",'multiserie-component-custom-tooltip');
   element.setAttribute("style",utils.convertReactStyleToHtml(tooltipStyle,"border: 2px solid;border-color: #ddd;border-radius: 4px;position:fixed;top:"+(divY)+"px;left:"+(divX+parentSelector.left)+"px;background-color:#000;"));
   var key='key_'+Math.random();
   key=key.split('.').join("_");
   return (
     <g transform={"translate("+translateX+","+translateY+")"} key={key} className='multiserie-component-custom-tooltip'>
     <Portal node={element}>{this.createInnerChildElement(this.state.areaChartChildComponent,this.hideAreaChartTooltip,this,this.state.areaChartOffset.isDataTip)}</Portal>
     <polygon  points={x1+","+y1+" "+x2+","+y2+" "+x3+","+y3} style={{fill:tooltipStyle.fill || "rgba(255,255,255,0.9)",fillOpacity:tooltipStyle.fillOpacity || "0.9",stroke:tooltipStyle.stroke || "#ccc"}}   />
     </g>
   )
  }
  renderColumnChartToolTipComponent=()=>{
    var width=document.body.clientWidth;
    var height=document.body.clientHeight;
    var innerWidth=this.state.columnChartChildComponent.props.config.width;
    var innerHeight=this.state.columnChartChildComponent.props.config.height;
    var tooltipStyle=this.state.columnChartOffset.tooltipStyle || {};
    var parentDiv=this.props.id;
    var translateX=0;
    var translateY=0;
    var y=this.state.columnChartOffset.y;
    var x=this.state.columnChartOffset.x;
    var bandwidth=parseFloat(this.state.columnChartOffset.bandwidth);
    var barHeight=parseFloat(this.state.columnChartOffset.barHeight);
    var triangleHeight=20;
    var triangleWidth=15;
    var x1=0,x2=0,x3=0,y1=0,y2=0,y3=0;
    var parentSelector=$("#"+parentDiv).offset();
    var divX=translateX;
     if(x+innerWidth+parentSelector.left<width ){
      //CBT:show on right
      translateX=x+bandwidth+triangleWidth;
      translateY=y+(barHeight/2)-(innerHeight/2);
      x1=-triangleWidth;
      y1=(innerHeight/2);
      x2=x1+triangleWidth+1;
      y2=y1-(triangleHeight/2)-2;
      x3=x1+triangleWidth+1;
      y3=y1+(triangleHeight/2)+2;
      divX=translateX;
    }else if((x+parentSelector.left)-innerWidth>0 ) {
      //CBT:show on left
      translateX=x-innerWidth-triangleHeight;
      translateY=y+(barHeight/2)-(innerHeight/2);
      x1=innerWidth+triangleWidth;
      y1=(innerHeight/2);
      x2=x1-triangleWidth-1;
      y2=y1-(triangleHeight/2)-4;
      x3=x1-triangleWidth-1;
      y3=y1+(triangleHeight/2)+4;
      divX=translateX-3;
    }else if(y-innerHeight-triangleHeight>0){
      //CBT:show on top
      translateX=x+(bandwidth/2)-(innerWidth/2);
      translateY=y-innerHeight-triangleHeight;
      x1=innerWidth/2
      y1=innerHeight+triangleHeight;
      x2=x1-(triangleWidth/2)-4;
      y2=y1-triangleHeight;
      x3=x1+(triangleWidth/2)+4;;
      y3=y1-triangleHeight;
    }else if(y+innerHeight+triangleHeight<height){
      //CBT:show on bottom
      translateX=x+(bandwidth/2)-(innerWidth/2);
      translateY=y+barHeight+triangleHeight;
      x1=innerWidth/2
      y1=0-triangleHeight;
      x2=x1-(triangleWidth/2)-4;
      y2=y1+triangleHeight;
      x3=x1+(triangleWidth/2)+4;;
      y3=y1+triangleHeight;
    }


    //CBT:if inner bar height greater that screen hight then reduce it    
    var divY=translateY+parentSelector.top;
    if(divY+innerHeight>(height*0.9)){
      var differenceHeight=(divY+innerHeight)-height;
      divY=divY-differenceHeight-75;
    }    
    var element=document.createElement("div");
    document.body.appendChild(element);
    element.setAttribute("class",'multiserie-component-custom-tooltip');
    element.setAttribute("style",utils.convertReactStyleToHtml(tooltipStyle,"border: 2px solid;border-color: #ddd;border-radius: 4px;position:fixed;top:"+(divY)+"px;left:"+(divX+parentSelector.left)+"px;background-color:#000;"));
    var key='key_'+Math.random();
    key=key.split('.').join("_");
    return (
      <g transform={"translate("+translateX+","+translateY+")"} key={key} className='multiserie-component-custom-tooltip'>
      <Portal node={element}>{this.createInnerChildElement(this.state.columnChartChildComponent,this.hideColumnChartTooltip,this,this.state.columnChartOffset.isDataTip)}</Portal>
      <polygon  points={x1+","+y1+" "+x2+","+y2+" "+x3+","+y3} style={{fill:tooltipStyle.fill || "rgba(255,255,255,0.9)",fillOpacity:tooltipStyle.fillOpacity || "0.9",stroke:tooltipStyle.stroke || "#ccc"}}   />
      </g>
    )
  }
  renderColumnGroupChartToolTipComponent=()=>{
    var width=document.body.clientWidth;
    var height=document.body.clientHeight;
    var innerWidth=this.state.columnGroupChartChildComponent.props.config.width;
    var innerHeight=this.state.columnGroupChartChildComponent.props.config.height;
    var tooltipStyle=this.state.columnGroupChartOffset.tooltipStyle || {};
    var parentDiv=this.props.id;
    var translateX=0;
    var translateY=0;
    var y=this.state.columnGroupChartOffset.y;
    var x=this.state.columnGroupChartOffset.x;
    var bandwidth=parseFloat(this.state.columnGroupChartOffset.bandwidth);
    var barHeight=parseFloat(this.state.columnGroupChartOffset.barHeight);
    var triangleHeight=15;
    var triangleWidth=10;
    var x1=0,x2=0,x3=0,y1=0,y2=0,y3=0;
    var parentSelector=$("#"+parentDiv).offset();
    var divX=translateX;
     if(x+innerWidth+parentSelector.left<width ){
      //CBT:show on right
      translateX=x+bandwidth+triangleWidth;
      translateY=y+(barHeight/2)-(innerHeight/2);
      x1=-triangleWidth;
      y1=(innerHeight/2);
      x2=x1+triangleWidth+1;
      y2=y1-(triangleHeight/2)-2;
      x3=x1+triangleWidth+1;
      y3=y1+(triangleHeight/2)+2;
      divX=translateX;
    }else if((x+parentSelector.left)-innerWidth>0 ) {
      //CBT:show on left
      translateX=x-innerWidth-triangleHeight;
      translateY=y+(barHeight/2)-(innerHeight/2);
      x1=innerWidth+triangleWidth;
      y1=(innerHeight/2);
      x2=x1-triangleWidth-1;
      y2=y1-(triangleHeight/2)-4;
      x3=x1-triangleWidth-1;
      y3=y1+(triangleHeight/2)+4;
      divX=translateX-3;
    }else if(y-innerHeight-triangleHeight>0){
      //CBT:show on top
      translateX=x+(bandwidth/2)-(innerWidth/2);
      translateY=y-innerHeight-triangleHeight;
      x1=innerWidth/2
      y1=innerHeight+triangleHeight;
      x2=x1-(triangleWidth/2)-4;
      y2=y1-triangleHeight;
      x3=x1+(triangleWidth/2)+4;;
      y3=y1-triangleHeight;
    }else if(y+innerHeight+triangleHeight<height){
      //CBT:show on bottom
      translateX=x+(bandwidth/2)-(innerWidth/2);
      translateY=y+barHeight+triangleHeight;
      x1=innerWidth/2
      y1=0-triangleHeight;
      x2=x1-(triangleWidth/2)-4;
      y2=y1+triangleHeight;
      x3=x1+(triangleWidth/2)+4;;
      y3=y1+triangleHeight;
    }
    //CBT:if inner bar height greater that screen hight then reduce it
    var divY=translateY+parentSelector.top;
    if(divY+innerHeight>(height*0.9)){
      var differenceHeight=(divY+innerHeight)-height;
      divY=divY-differenceHeight-75;
    }
   var element=document.createElement("div");
   document.body.appendChild(element);
   element.setAttribute("class",'multiserie-component-custom-tooltip');
   element.setAttribute("style",utils.convertReactStyleToHtml(tooltipStyle,"border: 2px solid;border-color: #ddd;border-radius: 4px;position:fixed;top:"+(divY)+"px;left:"+(divX+parentSelector.left)+"px;background-color:#000;"));
   var key='key_'+Math.random();
   key=key.split('.').join("_");
   return (
     <g transform={"translate("+translateX+","+translateY+")"} key={key} className='multiserie-component-custom-tooltip'>
     <Portal node={element}>{this.createInnerChildElement(this.state.columnGroupChartChildComponent,this.hideColumnGroupChartTooltip,this,this.state.columnGroupChartOffset.isDataTip)}</Portal>
     <polygon  points={x1+","+y1+" "+x2+","+y2+" "+x3+","+y3} style={{fill:tooltipStyle.fill || "rgba(255,255,255,0.9)",fillOpacity:tooltipStyle.fillOpacity || "0.9",stroke:tooltipStyle.stroke || "#ccc"}}   />
     </g>
   )
  }

  createInnerChildElement(chartComponent,hideChart,self,isDataTip){
    return (<div>
      {isDataTip && <div onClick={hideChart}><span style={$.extend({cursor:"pointer",fontSize: "20px",color:"white",float: "right",marginRight:"5px"},true,(self.props.config.closeIconStyle || {}))}>&times;</span></div>}
      {chartComponent}
    </div>)
  }
  
  render() {
    var that = this;
    var chartConfig=$.extend(true,{},this.props.config);
    var globalTooltip=null;
    var margins = chartConfig.margins;
    var svgDimensions = {
      width: chartConfig.width,
      height:chartConfig.height
    }
    // var data=chartConfig.data;
    var primaryXAxis='';
    var primaryXAxisPadding='';
    let primaryYAxisPadding="";
    var stackLayers='';
    var primaryStackYAxis='';
    var secondaryStackYAxis='';
    var secondorXAxis='';
    var xAxisPrimaryCategories=[];
    var xAxisSecondaryCategories=[];
    var xAxisPrimaryScaleType=[];
    var xAxisSecondaryScaleType=[];
    var yAxisSecondaryCategories=[];
    var yAxisPrimaryCategories=[];
    var yAxisPrimaryScaleType=[];
    var yAxisSecondaryScaleType=[];
    var gridLineXWidth=0;
    var gridLineYWidth=0;
    var gridLineYAxis=null;
    var isStackLabelsRequired=false;
    let isGroupDataHaveNegativeValue=false;
    var stackLabels={};
    var maxBarWidth=chartConfig.maxBarWidth ? parseFloat(chartConfig.maxBarWidth) : null; 
    if((typeof(chartConfig.globalTooltip)!=null && typeof(chartConfig.globalTooltip)=='object') || (chartConfig.globalTooltip==true) ){
      globalTooltip=(typeof(chartConfig.globalTooltip)!=null && typeof(chartConfig.globalTooltip)=='object') ? chartConfig.globalTooltip : {};
    }
    var globalTooltipLineStyle=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.lineStyle || {}) : {};
    
    var isBarChart=0;
    var barChartConfig=chartConfig.series.filter(function(d,index){
      return d.type.trim().toLowerCase()=='bar' || d.type.trim().toLowerCase()=='processbar'  && (that.state.disabledSeriesIndex.indexOf(index)==-1);
    });
    if(barChartConfig.length>0){
      isBarChart=1;
    }
    var isVerticalAreaChart=0;
    var verticalAreaChartConfig=chartConfig.series.filter(function(d,index){
      return (d.type.trim().toLowerCase()=='verticalareaspline' || d.type.trim().toLowerCase()=='verticalarea')  && (that.state.disabledSeriesIndex.indexOf(index)==-1);;
    });
    if(verticalAreaChartConfig.length>0){
      isVerticalAreaChart=1;
    }

    var isVerticalLineChart=0;
    var verticalLineChartConfig=chartConfig.series.filter(function(d,index){
      return (d.type.trim().toLowerCase()=='verticalspline' || d.type.trim().toLowerCase()=='verticalline')  && (that.state.disabledSeriesIndex.indexOf(index)==-1);;
    });
    if(verticalLineChartConfig.length>0){
      isVerticalLineChart=1;
    }

    var isSwapAxis=(isBarChart==1 ? isBarChart : (isVerticalAreaChart==1 ? isVerticalAreaChart : (isVerticalLineChart==1 ? isVerticalLineChart : 0)));

    var isPrimaryXAxisRequired=false;
    var isSecondaryXAxisRequired=false;
    var maxAxisLabelChar=chartConfig.maxAxisLabelChar;
    var secondoryXAxis='';
    if(chartConfig.hasOwnProperty('xAxis')){
      //CBT:if series data contains bar chart type then consider yAxis as xAxis
      if(isSwapAxis==1){
        //CBT:this is yAxis config.we are making xaxis from this
        chartConfig.yAxis.forEach(function(d){
          var zeroBase =d.zeroBase==undefined ? true : d.zeroBase;
          if(d.hasOwnProperty('stackLabels')){
            isStackLabelsRequired=d.stackLabels.enabled ? d.stackLabels.enabled : false;
            stackLabels=d.stackLabels ? d.stackLabels : {};
          }
          if(d.opposite==true){
            var xAxisSecondaryData=[];
            xAxisSecondaryData=chartConfig.series.filter(function(d,index){
              // return d.yAxis==1;
              return d.yAxis==1 && that.state.disabledSeriesIndex.indexOf(index)==-1;
              
            });
            if(xAxisSecondaryData.length>0){
              isSecondaryXAxisRequired=true;
            }
            xAxisSecondaryData=xAxisSecondaryData.map(function(d){
              return d.data.map(function(d){
                return (typeof d =='object' && d!=null) ? d.data : d;
              });
            });
            var maxValue = d3.max(xAxisSecondaryData.map(function(d){ return d3.max(d)}));
            var minValue=d3.min(xAxisSecondaryData.map(function(d){ return d3.min(d)}));
            var minMaxValues=ScaleUtils.calculateMinMaxValue(minValue,maxValue,zeroBase,d.ticks);
            minValue=minMaxValues.minValue;
            maxValue=minMaxValues.maxValue;
            var xScaleVar = d3.scaleLinear()
                            .domain(d.hasOwnProperty('domain') ? d.domain : [minValue, maxValue])
                            .range([svgDimensions.width - margins.left, margins.right])
            d.scale=xScaleVar;
            d.tickSize= svgDimensions.height - margins.top - margins.bottom;
            //CBT:this is for secondary right y axis
            secondoryXAxis=d;
            d.translate=`translate(0, ${margins.top})`;
            d.orient='Bottom';
          }else{
            var xAxisPrimaryData=[];
            xAxisPrimaryData=chartConfig.series.filter(function(d,index){
              return (d.yAxis==0 || d.yAxis==undefined || d.yAxis==null) && (that.state.disabledSeriesIndex.indexOf(index)==-1);
            });
            if(xAxisPrimaryData.length>0){
              isPrimaryXAxisRequired=true;
            }
            xAxisPrimaryData=xAxisPrimaryData.map(function(d){
              return d.data.map(function(d){
                return (typeof d =='object' && d!=null) ? d.data : d;
              });
            });
            var maxValue = d3.max(xAxisPrimaryData.map(function(d){ return d3.max(d)}));
            var minValue=d3.min(xAxisPrimaryData.map(function(d){ return d3.min(d)}));
            var minMaxValues=ScaleUtils.calculateMinMaxValue(minValue,maxValue,zeroBase,d.ticks);
            minValue=minMaxValues.minValue;
            maxValue=minMaxValues.maxValue;
            var xScaleVar = d3.scaleLinear()
                            .domain(d.hasOwnProperty('domain') ? d.domain : [minValue, maxValue])
                            .range([margins.left, svgDimensions.width - margins.right])
            d.scale=xScaleVar;
            d.tickSize= svgDimensions.height - margins.top - margins.bottom;
            //CBT:this is for primary left y axis
            primaryXAxis=d;
            d.translate=`translate(0, ${svgDimensions.height - margins.bottom})`;
          }
          if(d.gridLineWidth !=undefined && d.gridLineWidth!=null ){
            gridLineXWidth=d.gridLineWidth;
          }
          d.orient='Bottom';
        })
      }else{
        chartConfig.xAxis.forEach(function(d){
          var padding= d.padding == null ? 0.2 : d.padding;
          var paddingOuter= d.paddingOuter == null ? 0.1 : d.paddingOuter;
          // var xScaleVar = d3.scaleBand()
          var domainValues=d.categories.map(function(category){
            return (typeof(category)=='object' && category!=null) ? category.data : category;
          });  
                  
          var xScaleVar = ScaleUtils.AxiomScaleBand()
          .padding(padding)
          .paddingOuter(paddingOuter)
          .domain(domainValues)
          .range([margins.left, svgDimensions.width - margins.right])
          .maxBarWidth(maxBarWidth);
          if(d.hasOwnProperty('scaleType') && d.scaleType.toLowerCase()=='scalepoint'){
            xScaleVar = d3.scalePoint()
            .domain(domainValues)
            .range([margins.left, svgDimensions.width - margins.right]);
          }
          

          d.scale=xScaleVar;
          d.tickSize= svgDimensions.height - margins.top - margins.bottom;
          
          if(d.opposite==true){
            xAxisSecondaryCategories=d.categories;
            xAxisSecondaryScaleType='scaleband';
            if(d.hasOwnProperty('scaleType') && d.scaleType.toLowerCase()=='scalepoint'){
              xAxisSecondaryScaleType=d.scaleType.toLowerCase();
            }
            //CBT:this is for secondary top x axis
            secondorXAxis=d;
            var translateY=margins.top;
            if(d.translateY!=null){
              translateY=translateY+d.translateY;
            }
            var translateX=0;
            if(d.translateX!=null){
              translateX=translateX+d.translateX;
            }
            d.translate= `translate(${translateX}, ${translateY})`;
          }else{
            xAxisPrimaryCategories=d.categories;
            xAxisPrimaryScaleType='scaleband';
            if(d.hasOwnProperty('scaleType') && d.scaleType.toLowerCase()=='scalepoint'){
              xAxisPrimaryScaleType=d.scaleType.toLowerCase();
            }
            //CBT:this is for primary bottom x axis
            primaryXAxis=d;
            var translateY=svgDimensions.height - margins.bottom;
            if(d.translateY!=null){
              translateY=translateY+d.translateY;
            }
            var translateX=0;
            if(d.translateX!=null){
              translateX=translateX+d.translateX;
            }
            d.translate= `translate(${translateX}, ${translateY})`;
          }
          if(d.gridLineWidth !=undefined && d.gridLineWidth!=null ){
            gridLineXWidth=d.gridLineWidth;
          }
        })
      }
    }
   //CBT:check wheather it is for column with stack column chart
   var chartConfigWithStackColumn=chartConfig.series.filter(function(d,index){
    return d.type.trim().toLowerCase()=='column' && d.hasOwnProperty('stacking')==true && (that.state.disabledSeriesIndex.indexOf(index)==-1);
   });

   var chartConfigWithoutStackColumn=chartConfig.series.filter(function(d,index){
    return d.type.trim().toLowerCase()!='column' && d.hasOwnProperty('stacking')==false && (that.state.disabledSeriesIndex.indexOf(index)==-1);
   });
    var isStackColumnChart=chartConfigWithStackColumn.length>=1?1:0;


    //CBT:check wheather it is for column with stack Bar chart
   const chartConfigWithStackBar=chartConfig.series.filter(function(d,index){
    return d.type.trim().toLowerCase()=='bar' && d.hasOwnProperty('stacking')==true && (that.state.disabledSeriesIndex.indexOf(index)==-1);
   });

   const chartConfigWithoutStackBar=chartConfig.series.filter(function(d,index){
    return d.type.trim().toLowerCase()!='bar' && d.hasOwnProperty('stacking')==false && (that.state.disabledSeriesIndex.indexOf(index)==-1);
   });

   const isStackBarChart=chartConfigWithStackBar.length>=1?1:0;

    var that=this;
    var primaryYAxis='';
    var isPrimaryYAxisRequired=false;
    var isSecondaryYAxisRequired=false;
    var secondoryYAxis='';
    if(chartConfig.hasOwnProperty('yAxis')){
      //CBT:if series data contains bar chart type then consider xAxis as yAxis
      if(isSwapAxis==1){
        //CBT:this is xAxis config.we are making yaxis from this
        chartConfig.xAxis.forEach(function(d){
          var padding= d.padding == null ? 0.2 : d.padding;
          var paddingOuter= d.paddingOuter == null ? 0.1 : d.paddingOuter;
          // var xScaleVar = d3.scaleBand()
          var domainValues=d.categories.map(function(category){
            return (typeof(category)=='object' && category!=null) ? category.data : category;
          });
          var yScaleVar = ScaleUtils.AxiomScaleBand()
          .padding(padding)
          .paddingOuter(paddingOuter)
          .domain(domainValues)
          .range([svgDimensions.height - margins.bottom, margins.top])
          .maxBarWidth(maxBarWidth);
          if(d.hasOwnProperty('scaleType') && d.scaleType.toLowerCase()=='scalepoint'){
            yScaleVar = d3.scalePoint()
            .domain(domainValues)
            .range([svgDimensions.height - margins.bottom, margins.top]);
          }
          d.scale=yScaleVar;
          d.tickSize=  svgDimensions.width - margins.left - margins.right;
          
          if(d.opposite==true){
            yAxisSecondaryCategories=d.categories;
            yAxisSecondaryScaleType='scaleband';
            if(d.hasOwnProperty('scaleType') && d.scaleType.toLowerCase()=='scalepoint'){
              yAxisSecondaryScaleType=d.scaleType.toLowerCase();
            }
            //CBT:this is for secondary top x axis
            secondoryYAxis=d;
            d.translate= `translate(${svgDimensions.width-margins.right}, 0)`;
            d.orient='Left';
          }else{
            yAxisPrimaryCategories=d.categories;
            yAxisPrimaryScaleType='scaleband';
            if(d.hasOwnProperty('scaleType') && d.scaleType.toLowerCase()=='scalepoint'){
              yAxisPrimaryScaleType=d.scaleType.toLowerCase();
            }
            isPrimaryYAxisRequired=true;
            //CBT:this is for primary bottom y axis
            primaryYAxis=d;
            d.translate= `translate(${margins.left}, 0)`;
            d.orient='Left';
          }
          if(d.gridLineWidth !=undefined && d.gridLineWidth!=null ){
            gridLineYWidth=d.gridLineWidth;
          }
        })
      }else{
        chartConfig.yAxis.forEach(function(d){
          var zeroBase =d.zeroBase==undefined ? true : d.zeroBase;
          if(d.hasOwnProperty('stackLabels')){
            isStackLabelsRequired=d.stackLabels.enabled ? d.stackLabels.enabled : false;
            stackLabels=d.stackLabels ? d.stackLabels : {};
          }
          // var yAxisField=d.field;
          if(d.opposite==true){
            var yAxisSecondaryData=[];
            yAxisSecondaryData=chartConfig.series.filter(function(d,index){
              // return d.yAxis==1;
              return d.yAxis==1 && that.state.disabledSeriesIndex.indexOf(index)==-1;
              
            });
            if(yAxisSecondaryData.length>0){
              isSecondaryYAxisRequired=true;
            }
            yAxisSecondaryData=yAxisSecondaryData.map(function(d){
              return d.data.map(function(d){
                return (typeof d =='object' && d!=null) ? d.data : d;
              });
            });
            var maxValue = d3.max(yAxisSecondaryData.map(function(d){ return d3.max(d)}));
            var minValue=d3.min(yAxisSecondaryData.map(function(d){ return d3.min(d)}));
            if(d.labels && d.labels.format && d.labels.format.indexOf("%") != -1){
              maxValue = maxValue * 100;
              minValue = minValue * 100;  
            }
            var minMaxValues=ScaleUtils.calculateMinMaxValue(minValue,maxValue,zeroBase,d.ticks);
            
            minValue=minMaxValues.minValue;
            maxValue=minMaxValues.maxValue;
            if(d.labels && d.labels.format && d.labels.format.indexOf("%") != -1){
              maxValue = maxValue / 100;
              minValue = minValue / 100;  
            }
            var yScaleVar = d3.scaleLinear()
                            .domain(d.hasOwnProperty('domain') ? d.domain : [minValue, maxValue])
                            .range([svgDimensions.height - margins.bottom, margins.top])
            d.scale=yScaleVar;
            d.tickSize= svgDimensions.width - margins.left - margins.right;
            //CBT:this is for secondary right y axis
            secondoryYAxis=d;
            var translateX=svgDimensions.width-margins.right;
            if(d.translateX!=null){
              translateX=translateX+d.translateX;
            }
            var translateY=0;
            if(d.translateY!=null){
              translateY=translateY+d.translateY;
            }
            d.translate=`translate(${translateX}, ${translateY})`;
          }else{
            var gridLinePoints=[];
            if(d.gridLine!=null && d.gridLine!=undefined){
              gridLineYAxis=d.gridLine;
              gridLinePoints=gridLineYAxis.points;
            }
            var yAxisPrimaryData=[];
            yAxisPrimaryData=chartConfig.series.filter(function(d,index){
              return (d.yAxis==0 || d.yAxis==undefined || d.yAxis==null) && (that.state.disabledSeriesIndex.indexOf(index)==-1);
            });
            if(yAxisPrimaryData.length>0){
              isPrimaryYAxisRequired=true;
            }
            yAxisPrimaryData=yAxisPrimaryData.map(function(d){
              if(d.type=='bollinger'){
                // Object.keys(d).map(function(key){return d[key]})
                var dataPoints=[];
                d.data.forEach(function(point){
                  if(typeof point =='object' && point!=null) {
                    dataPoints=dataPoints.concat(Object.keys(point).map(function(key){return point[key]}));
                  }else{
                    dataPoints=dataPoints.concat([point]);
                  } 
                })
                return dataPoints;
              }else{
                return d.data.map(function(d){
                  return (typeof d =='object' && d!=null) ? d.data : d;
                });
              }
            });
            var maxValue = d3.max(yAxisPrimaryData.map(function(d){ return d3.max(d)}));
            var minValue=d3.min(yAxisPrimaryData.map(function(d){ return d3.min(d)}));
            if(d.labels && d.labels.format && d.labels.format.indexOf("%") != -1){
              maxValue = maxValue * 100;
              minValue = minValue * 100;  
            }
            
            var minMaxValues=ScaleUtils.calculateMinMaxValue(minValue,maxValue,zeroBase,d.ticks);
            if(gridLinePoints.length!=0){
              var minPoints=d3.min(gridLinePoints.map(mind => mind.y1));
              var maxPoints=d3.max(gridLinePoints.map(maxd => maxd.y1));
              if(minPoints<minMaxValues.minValue){
                minMaxValues.minValue=minPoints;
              }else{
                minMaxValues.minValue=minValue;
              }
              if(maxPoints>minMaxValues.maxValue){
                minMaxValues.maxValue=maxPoints;
              }else{
                minMaxValues.maxValue=maxValue;
              }
              minMaxValues=ScaleUtils.calculateMinMaxValue(minMaxValues.minValue,minMaxValues.maxValue,zeroBase,d.ticks);
            }
            minValue=minMaxValues.minValue;
            maxValue=minMaxValues.maxValue;
            if(d.labels && d.labels.format && d.labels.format.indexOf("%") != -1){
              maxValue = maxValue / 100;
              minValue = minValue / 100;  
            }
            var yScaleVar = d3.scaleLinear()
                            .domain(d.hasOwnProperty('domain') ? d.domain : [minValue, maxValue])
                            .range([svgDimensions.height - margins.bottom, margins.top])
            d.scale=yScaleVar;
            d.tickSize= svgDimensions.width - margins.left - margins.right;
            //CBT:this is for primary left y axis
            primaryYAxis=d;
            var translateX=margins.left;
            if(d.translateX!=null){
              translateX=translateX+d.translateX;
            }
            d.translate=`translate(${translateX}, 0)`;
            var translateY=0;
            if(d.translateY!=null){
              translateY=translateY+d.translateY;
            }
            d.translate=`translate(${translateX}, ${translateY})`;
          }
          if(d.gridLineWidth !=undefined && d.gridLineWidth!=null ){
            gridLineYWidth=d.gridLineWidth;
          }
        })
      }
    }
    //CBT:set default type to null
    chartConfig.series.forEach(function(d,index){
      d.data.forEach(data=>{
        let value=data;
        if(value!=null && typeof(value)=='object'){
          value=value.data;
        }
        if(value<0){
          isGroupDataHaveNegativeValue=true;
        }
      })
      d.type=d.type ? d.type :'n/a';
    });

    var chartConfigWithBar=chartConfig.series.filter(function(d,index){
      return d.type.trim().toLowerCase()=='column' && (that.state.disabledSeriesIndex.indexOf(index)==-1);
    });

    //CBT:Check wheather it is for column with group Column chart
    var chartConfigWithGroupColumn=chartConfig.series.filter(function(d,index){
      d.isPartOfGroupColumn=0;
      return d.type.trim().toLowerCase()=='column' && d.hasOwnProperty('stacking')==false && (that.state.disabledSeriesIndex.indexOf(index)==-1);
    });

    //CBT:Check wheather it is for column with group Bar chart
    var chartConfigWithGroupBar=chartConfig.series.filter(function(d,index){
      d.isPartOfGroupBar=0;
      return d.type.trim().toLowerCase()=='bar' && d.hasOwnProperty('stacking')==false && (that.state.disabledSeriesIndex.indexOf(index)==-1);
    });

    var isGroupColumn=chartConfigWithGroupColumn.length>1?1:0;
    if(chartConfigWithGroupColumn.length==1 && chartConfigWithStackColumn.length==1){
      isGroupColumn=1;
      chartConfigWithGroupColumn.push(chartConfigWithStackColumn[0]);
    }

    var isGroupBar=chartConfigWithGroupBar.length>1?1:0;
    if(chartConfigWithGroupBar.length==1 && chartConfigWithStackBar.length==1){
      isGroupBar=1;
      chartConfigWithGroupBar.push(chartConfigWithStackBar[0]);
    }

    //CBT:set isPartOfGroupColumn or isPartOfStackColumn or isPartOfGroupBar start
    if(isGroupColumn==1){
      chartConfigWithGroupColumn.forEach(function(d){
        d.isPartOfGroupColumn=1;
      });
      primaryXAxisPadding={scale:ScaleUtils.AxiomScaleBand()
        .padding(0.05)};
      primaryXAxisPadding.scale.domain(chartConfigWithGroupColumn.map(function(d,index){
        return 'groupDomain_'+index
      })).range([0, primaryXAxis.scale.bandwidth()]);
    }
    if(isGroupBar==1){
      chartConfigWithGroupBar.forEach(function(d){
        d.isPartOfGroupBar=1;
      });
      primaryYAxisPadding={scale:ScaleUtils.AxiomScaleBand()
        .padding(0.05)};
      primaryYAxisPadding.scale.domain(chartConfigWithGroupBar.map(function(d,index){
        return 'groupDomain_'+index
      })).range([0, primaryYAxis.scale.bandwidth()]);
    }
    if(isStackColumnChart==1){
      chartConfigWithStackColumn.forEach(function(d){
        d.isPartOfStackColumn=1;
      });
      var stackBarData=[];
      var stackBarKeys=[];
      var defaultDataLabelFormat=function(d){
        return d;
      };//"0,0.[00]"
      xAxisPrimaryCategories.forEach(function(xCategory,index){
        xCategory=(typeof(xCategory)=='object' && xCategory!=null) ? xCategory.data : xCategory;
        var tempObj={};  
        tempObj["xCategory"]=xCategory;
        var stackTotal=0;
        chartConfigWithStackColumn.forEach(function(stackBarData,innerIndex){
          var yAxisConfig=stackBarData.yAxis==1 ? secondoryYAxis : primaryYAxis;
          stackBarData.tooltipStyle=stackBarData.tooltipStyle ? stackBarData.tooltipStyle :{};
          stackBarData.tooltipStyle.format= stackBarData.tooltipStyle.format!=undefined ? stackBarData.tooltipStyle.format : ((yAxisConfig.labels && yAxisConfig.labels.format) || defaultDataLabelFormat);
          stackBarData.tooltipStyle.prefix= stackBarData.tooltipStyle.prefix!=undefined ? stackBarData.tooltipStyle.prefix : ((yAxisConfig.labels && yAxisConfig.labels.prefix) || '');
          stackBarData.tooltipStyle.postfix= stackBarData.tooltipStyle.postfix!=undefined ? stackBarData.tooltipStyle.postfix : ((yAxisConfig.labels && yAxisConfig.labels.postfix) || '');

          stackBarData.dataLabels=stackBarData.dataLabels ? stackBarData.dataLabels :{};
          stackBarData.dataLabels.format= stackBarData.dataLabels.format!=undefined ? stackBarData.dataLabels.format : ((yAxisConfig.labels && yAxisConfig.labels.format) || defaultDataLabelFormat);
          stackBarData.dataLabels.prefix= stackBarData.dataLabels.prefix!=undefined ? stackBarData.dataLabels.prefix : ((yAxisConfig.labels && yAxisConfig.labels.prefix) || '');
          stackBarData.dataLabels.postfix= stackBarData.dataLabels.postfix!=undefined ? stackBarData.dataLabels.postfix : ((yAxisConfig.labels && yAxisConfig.labels.postfix) || '');
          tempObj['stackKey_'+innerIndex]= (stackBarData.data[index]!=null && typeof(stackBarData.data[index])=='object') ?stackBarData.data[index]["data"] :stackBarData.data[index] ;
          tempObj['stackInnerText_' + innerIndex] = (stackBarData.data[index] != null && typeof (stackBarData.data[index]) == 'object') ? (stackBarData.data[index]["displayData"] != null ? stackBarData.data[index]["displayData"] :stackBarData.data[index]["data"]) : stackBarData.data[index];
          tempObj['yAxis_'+innerIndex]=stackBarData.yAxis;
          tempObj['fillColor_'+innerIndex]=stackBarData.fillColor;
          tempObj['fillOpacity_'+innerIndex]=stackBarData.fillOpacity;
          tempObj['dataLabels_'+innerIndex]=stackBarData.dataLabels;
          tempObj['tooltip_'+innerIndex]=stackBarData.tooltip;
          tempObj['tooltipStyle_'+innerIndex]=stackBarData.tooltipStyle || {};
          tempObj['tooltipPosition_'+innerIndex]=stackBarData.tooltipPosition || "default";
          tempObj['name_'+innerIndex]=stackBarData.name;
          tempObj['onStackBarClick_'+innerIndex]=stackBarData.onStackBarClick;
          tempObj['closeIconStyle_'+innerIndex]=stackBarData.closeIconStyle;
          tempObj['tooltipConfig_'+innerIndex]=stackBarData.tooltipConfig || {};
          tempObj['oriData_'+innerIndex]=stackBarData.data[index];
          stackTotal=stackTotal+tempObj['stackKey_'+innerIndex];
          if(index==0){
            stackBarKeys.push('stackKey_'+innerIndex);
          }
        });
        tempObj["stackTotal"]=stackTotal;
        stackBarData.push(tempObj); 
      });
      
      stackLayers = d3.stack()
            .keys(stackBarKeys)
            .offset(d3.stackOffsetDiverging)
            (stackBarData);
      if(isSwapAxis==0){
        chartConfig.yAxis.forEach(function(d){
          var zeroBase =d.zeroBase==undefined ? true : d.zeroBase;
          if(d.opposite==true){
          }else{
            var stackMinValue = d3.min(stackLayers, stackMin);
            var stackMaxValue = d3.max(stackLayers, stackMax);
  
            var minValue = stackMinValue;
            var maxValue = stackMaxValue;
  
            if(chartConfigWithoutStackColumn.length != 0) {
              var yDataWithoutStackBar = chartConfigWithoutStackColumn.map(function(d) {
                return d.data.map(function(d){
                  return (typeof d =='object' && d!=null) ? d.data : d;
                });
              });
              var withoutStackMinValue=d3.min(yDataWithoutStackBar.map(function(d){ return d3.min(d)}));
              var withoutStackMaxValue = d3.max(yDataWithoutStackBar.map(function(d){ return d3.max(d)}));
  
              minValue = Math.min(stackMinValue, withoutStackMinValue);
              maxValue = Math.max(stackMaxValue, withoutStackMaxValue);
            }
            
            if(d.hasOwnProperty('minValue')==true && d.hasOwnProperty('maxValue')==true){
              minValue=d.minValue;
              maxValue=d.maxValue;
            }else{
              var minMaxValues=ScaleUtils.calculateMinMaxValue(minValue,maxValue,zeroBase,d.ticks);
              minValue=minMaxValues.minValue;
              maxValue=minMaxValues.maxValue;
            }
            d.scale.domain([minValue, maxValue])
            primaryYAxis.scale.domain([minValue, maxValue]);
          }
        });
      }else{
        chartConfig.xAxis.forEach(function(d){
          var zeroBase =d.zeroBase==undefined ? true : d.zeroBase;
          if(d.opposite==true){
          }else{
            var stackMinValue = d3.min(stackLayers, stackMin);
            var stackMaxValue = d3.max(stackLayers, stackMax);
  
            var minValue = stackMinValue;
            var maxValue = stackMaxValue;
  
            if(chartConfigWithoutStackColumn.length != 0) {
              var yDataWithoutStackBar = chartConfigWithoutStackColumn.map(function(d) {
                return d.data.map(function(d){
                  return (typeof d =='object' && d!=null) ? d.data : d;
                });
              });
              var withoutStackMinValue=d3.min(yDataWithoutStackBar.map(function(d){ return d3.min(d)}));
              var withoutStackMaxValue = d3.max(yDataWithoutStackBar.map(function(d){ return d3.max(d)}));
  
              minValue = Math.min(stackMinValue, withoutStackMinValue);
              maxValue = Math.max(stackMaxValue, withoutStackMaxValue);
            }
            
            if(d.hasOwnProperty('minValue')==true && d.hasOwnProperty('maxValue')==true){
              minValue=d.minValue;
              maxValue=d.maxValue;
            }else{
              var minMaxValues=ScaleUtils.calculateMinMaxValue(minValue,maxValue,zeroBase,d.ticks);
              minValue=minMaxValues.minValue;
              maxValue=minMaxValues.maxValue;
            }
            // d.scale.domain([minValue, maxValue])
            primaryXAxis.scale.domain([minValue, maxValue]);
          }
        });
      }
    }
    //CBT:set isPartOfGroupColumn or isPartOfStackColumn or isPartOfGroupBar End
      function stackMin(stackLayers) {
          return d3.min(stackLayers, function(d) {
              return d[0];
          });
      }
      function stackMax(stackLayers) {
            return d3.max(stackLayers, function(d) {
                return d[1];
            });
      }
    //CBT:set isPartOfStackBar start
    if(isStackBarChart==1){
      chartConfigWithStackBar.forEach(function(d){
        d.isPartOfStackBar=1;
      });
      var stackBarData=[];
      var stackBarKeys=[];
      var defaultDataLabelFormat=function(d){
        return d;
      };//"0,0.[00]"
      yAxisPrimaryCategories.forEach(function(yCategory,index){
        yCategory=(typeof(yCategory)=='object' && yCategory!=null) ? yCategory.data : yCategory;
        var tempObj={};  
        tempObj["yCategory"]=yCategory;
        var stackTotal=0;
        chartConfigWithStackBar.forEach(function(stackBarData,innerIndex){
          var xAxisConfig=stackBarData.xAxis==1 ? secondoryXAxis : primaryXAxis;
          stackBarData.tooltipStyle=stackBarData.tooltipStyle ? stackBarData.tooltipStyle :{};
          stackBarData.tooltipStyle.format= stackBarData.tooltipStyle.format!=undefined ? stackBarData.tooltipStyle.format : ((xAxisConfig.labels && xAxisConfig.labels.format) || defaultDataLabelFormat);
          stackBarData.tooltipStyle.prefix= stackBarData.tooltipStyle.prefix!=undefined ? stackBarData.tooltipStyle.prefix : ((xAxisConfig.labels && xAxisConfig.labels.prefix) || '');
          stackBarData.tooltipStyle.postfix= stackBarData.tooltipStyle.postfix!=undefined ? stackBarData.tooltipStyle.postfix : ((xAxisConfig.labels && xAxisConfig.labels.postfix) || '');

          stackBarData.dataLabels=stackBarData.dataLabels ? stackBarData.dataLabels :{};
          stackBarData.dataLabels.format= stackBarData.dataLabels.format!=undefined ? stackBarData.dataLabels.format : ((xAxisConfig.labels && xAxisConfig.labels.format) || defaultDataLabelFormat);
          stackBarData.dataLabels.prefix= stackBarData.dataLabels.prefix!=undefined ? stackBarData.dataLabels.prefix : ((xAxisConfig.labels && xAxisConfig.labels.prefix) || '');
          stackBarData.dataLabels.postfix= stackBarData.dataLabels.postfix!=undefined ? stackBarData.dataLabels.postfix : ((xAxisConfig.labels && xAxisConfig.labels.postfix) || '');
          tempObj['stackKey_'+innerIndex]= (stackBarData.data[index]!=null && typeof(stackBarData.data[index])=='object') ?stackBarData.data[index]["data"] :stackBarData.data[index] ;
          tempObj['stackInnerText_' + innerIndex] = (stackBarData.data[index] != null && typeof (stackBarData.data[index]) == 'object') ? (stackBarData.data[index]["displayData"] != null ? stackBarData.data[index]["displayData"] :stackBarData.data[index]["data"]) : stackBarData.data[index];
          tempObj['xAxis_'+innerIndex]=stackBarData.xAxis;
          tempObj['fillColor_'+innerIndex]=stackBarData.fillColor;
          tempObj['fillOpacity_'+innerIndex]=stackBarData.fillOpacity;
          tempObj['dataLabels_'+innerIndex]=stackBarData.dataLabels;
          tempObj['tooltip_'+innerIndex]=stackBarData.tooltip;
          tempObj['tooltipStyle_'+innerIndex]=stackBarData.tooltipStyle || {};
          tempObj['tooltipPosition_'+innerIndex]=stackBarData.tooltipPosition || "default";
          tempObj['name_'+innerIndex]=stackBarData.name;
          tempObj['onStackBarClick_'+innerIndex]=stackBarData.onStackBarClick;
          tempObj['closeIconStyle_'+innerIndex]=stackBarData.closeIconStyle;
          tempObj['tooltipConfig_'+innerIndex]=stackBarData.tooltipConfig || {};
          tempObj['oriData_'+innerIndex]=stackBarData.data[index];
          stackTotal=stackTotal+tempObj['stackKey_'+innerIndex];
          if(index==0){
            stackBarKeys.push('stackKey_'+innerIndex);
          }
        });
        tempObj["stackTotal"]=stackTotal;
        stackBarData.push(tempObj); 
      });
      
      stackLayers = d3.stack()
            .keys(stackBarKeys)
            .offset(d3.stackOffsetDiverging)
            (stackBarData);

      if(isSwapAxis==0){      
        chartConfig.yAxis.forEach(function(d){
          var zeroBase =d.zeroBase==undefined ? true : d.zeroBase;
          if(d.opposite==true){
          }else{
            var stackMinValue = d3.min(stackLayers, stackMin);
            var stackMaxValue = d3.max(stackLayers, stackMax);
  
            var minValue = stackMinValue;
            var maxValue = stackMaxValue;
  
            if(chartConfigWithoutStackBar.length != 0) {
              var yDataWithoutStackBar = chartConfigWithoutStackBar.map(function(d) {
                return d.data.map(function(d){
                  return (typeof d =='object' && d!=null) ? d.data : d;
                });
              });
              var withoutStackMinValue=d3.min(yDataWithoutStackBar.map(function(d){ return d3.min(d)}));
              var withoutStackMaxValue = d3.max(yDataWithoutStackBar.map(function(d){ return d3.max(d)}));
  
              minValue = Math.min(stackMinValue, withoutStackMinValue);
              maxValue = Math.max(stackMaxValue, withoutStackMaxValue);
            }
            
            if(d.hasOwnProperty('minValue')==true && d.hasOwnProperty('maxValue')==true){
              minValue=d.minValue;
              maxValue=d.maxValue;
            }else{
              var minMaxValues=ScaleUtils.calculateMinMaxValue(minValue,maxValue,zeroBase,d.ticks);
              minValue=minMaxValues.minValue;
              maxValue=minMaxValues.maxValue;
            }
            d.scale.domain([minValue, maxValue])
            primaryYAxis.scale.domain([minValue, maxValue]);
          }
        });
      }else{
        chartConfig.xAxis.forEach(function(d){
          var zeroBase =d.zeroBase==undefined ? true : d.zeroBase;
          if(d.opposite==true){
          }else{
            var stackMinValue = d3.min(stackLayers, stackMin);
            var stackMaxValue = d3.max(stackLayers, stackMax);
  
            var minValue = stackMinValue;
            var maxValue = stackMaxValue;
  
            if(chartConfigWithoutStackBar.length != 0) {
              var yDataWithoutStackBar = chartConfigWithoutStackBar.map(function(d) {
                return d.data.map(function(d){
                  return (typeof d =='object' && d!=null) ? d.data : d;
                });
              });
              var withoutStackMinValue=d3.min(yDataWithoutStackBar.map(function(d){ return d3.min(d)}));
              var withoutStackMaxValue = d3.max(yDataWithoutStackBar.map(function(d){ return d3.max(d)}));
  
              minValue = Math.min(stackMinValue, withoutStackMinValue);
              maxValue = Math.max(stackMaxValue, withoutStackMaxValue);
            }
            
            if(d.hasOwnProperty('minValue')==true && d.hasOwnProperty('maxValue')==true){
              minValue=d.minValue;
              maxValue=d.maxValue;
            }else{
              var minMaxValues=ScaleUtils.calculateMinMaxValue(minValue,maxValue,zeroBase,d.ticks);
              minValue=minMaxValues.minValue;
              maxValue=minMaxValues.maxValue;
            }
            // d.scale.domain([minValue, maxValue])
            primaryXAxis.scale.domain([minValue, maxValue]);
          }
        });
      }
      
    }
    //CBT:set  isPartOfStackBar End
    

    //CBT:prepare tickWidth for gridline start
    var tickXSize=0;
    var tickYSize=0;
    if(gridLineXWidth==1){
      tickXSize=chartConfig.height-margins.top-margins.bottom;
    }
    if(gridLineYWidth==1){
      tickYSize=chartConfig.width-margins.left-margins.right;
    }
    //CBT:prepare tickWidth for gridline END

    //CBT:prepare globalTooltip Data Start
    var globalTooltipData={};
    var globalTooltipDataForCallback={};
    if(globalTooltip!=null){
      chartConfig.hasOwnProperty('series') && chartConfig.series.map(function(d,index){
        var name=((d["name"]!=undefined &&  d["name"]!="")  ?d["name"] : 'Noname_'+index);
        if((d.tooltip==true || d.tooltip==undefined || (d.tooltip!=false && d.tooltip!=null && typeof(d.tooltip)=='object')) && (that.state.disabledSeriesIndex.indexOf(index)==-1)){
          var tooltipKey=(d.tooltip!=false && d.tooltip!=null && typeof(d.tooltip)=='object') ? (d.tooltip.key!=undefined ? d.tooltip.key : null ) : null;
          globalTooltipData[name]={
            data:d.data.map(function(d){
              return (typeof d =='object' && d!=null) ? (tooltipKey!=null ? d[tooltipKey] : d.data) :d;
          }),
          dataLabels:(d.yAxis==1 ? (secondoryYAxis.labels ? secondoryYAxis.labels :{}) : (primaryYAxis.labels ? primaryYAxis.labels :{}) ) //d.dataLabels || {},

          };

          if(d.type== "bollinger"){
            globalTooltipData['Upper']={
              data:d.data.map(function(d){
                return (typeof d =='object' && d!=null) ? d.upper :d;
            }),
            dataLabels:(d.yAxis==1 ? (secondoryYAxis.labels ? secondoryYAxis.labels :{}) : (primaryYAxis.labels ? primaryYAxis.labels :{}) ) //d.dataLabels || {}
            };
            globalTooltipData['Lower']={
              data:d.data.map(function(d){
                return (typeof d =='object' && d!=null) ? d.lower :d;
            }),
            dataLabels:(d.yAxis==1 ? (secondoryYAxis.labels ? secondoryYAxis.labels :{}) : (primaryYAxis.labels ? primaryYAxis.labels :{}) ) //d.dataLabels || {}
            };
          }
        }
        if((that.state.disabledSeriesIndex.indexOf(index)==-1)){
          globalTooltipDataForCallback[name]={
          data:d.data,
          dataLabels:(d.yAxis==1 ? (secondoryYAxis.labels ? secondoryYAxis.labels :{}) : (primaryYAxis.labels ? primaryYAxis.labels :{}) ) //d.dataLabels || {}
          };
        }
      });
    }
    var globalTooltipShowLine=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.showLine || false ) : false;
    if(globalTooltipShowLine==false){
      d3.selectAll(".globalTooltipsHighlightLine_"+that.props.id).style("display","none");
    } 
    //CBT:prepare globalTooltip Data End

    //CBT:title Subtitle changes start 
    var multiSeriesChartTitle=chartConfig.title || {};
    var multiSeriesChartSubTitle=chartConfig.subtitle || {};
    var containerId=chartConfig.containerId || null;
    //CBT:title Subtitle changes end 

    var that=this;
    var globalTooltipMouseOverCallbackTimer=null;
    var globalTooltipOnClickCallbackTimer=null;
    var globalTooltipMouseOutCallbackTimer=null;
    var translateX = this.props.config.translateX != undefined && this.props.config.translateX ? this.props.config.translateX : 0;
    var translateY =  this.props.config.translateY != undefined && this.props.config.translateY ? this.props.config.translateY : 0;
    return( 
      <g className = {"ReactD3MultiSeriesChart_"+(this.props.id || '')}
      transform = {"translate("+translateX+","+translateY+")"} >

      {multiSeriesChartTitle.text!=undefined && multiSeriesChartTitle.text!='' &&
        <text ref={(e)=>{this.chartTitle=e}} x={chartConfig.width/2} y={0} style={$.extend({textAnchor:'middle',fill:'#333333',fontSize:"18px",color:"#333333"},false,multiSeriesChartTitle.style || {})}>{multiSeriesChartTitle.text}</text>
      }
      {multiSeriesChartSubTitle.text!=undefined && multiSeriesChartSubTitle.text!='' &&
        <text ref={(e)=>{this.chartSubTitle=e}} x={chartConfig.width/2} y={0} style={$.extend({textAnchor:'middle',fill:'#333333',fontSize:"14px",color:"#333333"},false,multiSeriesChartSubTitle.style || {})}>{multiSeriesChartSubTitle.text}</text>
      }

 {chartConfig.hasOwnProperty('xAxis') &&  chartConfig.xAxis.map(function(d,index){
         return (<Axes axis={d} yAxisScale={primaryYAxis}  key={index} margins={margins} svgDimensions={svgDimensions} axisType='xAxis' mainDivId={`${that.props.id}`} id={`${that.props.id}_${index}`} 
                  tickSize={tickXSize} maxAxisLabelChar={maxAxisLabelChar} isSwapAxis={isSwapAxis} ></Axes>)
       })}
       {chartConfig.hasOwnProperty('yAxis') &&  chartConfig.yAxis.map(function(d,index){
         if(d.opposite==true && isSecondaryYAxisRequired==true){
            return (<Axes axis={d} key={index} margins={margins} svgDimensions={svgDimensions} axisType='yAxis' mainDivId={`${that.props.id}`} id={`${that.props.id}_${index}`} tickSize={tickYSize} maxAxisLabelChar={maxAxisLabelChar} isSwapAxis={isSwapAxis}></Axes>)
         }else if((d.opposite==undefined && isPrimaryYAxisRequired==true)){
            return (<Axes axis={d} key={index} margins={margins} svgDimensions={svgDimensions} axisType='yAxis' mainDivId={`${that.props.id}`} id={`${that.props.id}_${index}`} tickSize={tickYSize} maxAxisLabelChar={maxAxisLabelChar} isSwapAxis={isSwapAxis}></Axes>)
         }
         
       })}
       

       {isGroupColumn==1 && <GroupColumns  primaryYAxis={ primaryYAxis } secondoryYAxis={secondoryYAxis}
       primaryXAxis={primaryXAxis } secondorXAxis={secondorXAxis} chartConfigWithBar={chartConfigWithGroupColumn}
       xAxisPrimaryCategories={xAxisPrimaryCategories} xAxisSecondaryCategories={xAxisSecondaryCategories}
       margins={margins} config={{width:this.props.config.width,height:this.props.config.height}}  svgDimensions={svgDimensions} mainDivId={`${that.props.id}`}
       primaryXAxisPadding={primaryXAxisPadding} isGroupColumn={isGroupColumn} id={`${that.props.id}`}
       showColumnGroupChartTooltip={that.showColumnGroupChartTooltip} 
       hideColumnGroupChartTooltip={that.hideColumnGroupChartTooltip}>
       { that.state.columnGroupChartChildComponent &&
                              that.renderColumnGroupChartToolTipComponent()
          }
       </GroupColumns> }

       {isGroupBar==1 && <GroupBars  primaryYAxis={ primaryYAxis } secondoryYAxis={secondoryYAxis}
       primaryXAxis={primaryXAxis } secondorXAxis={secondorXAxis} chartConfigWithBar={chartConfigWithGroupBar}
       yAxisPrimaryCategories={yAxisPrimaryCategories} yAxisSecondaryCategories={yAxisSecondaryCategories}
       margins={margins} config={{width:this.props.config.width,height:this.props.config.height}}  svgDimensions={svgDimensions} mainDivId={`${that.props.id}`}
       primaryYAxisPadding={primaryYAxisPadding} isGroupBar={isGroupBar} id={`${that.props.id}`}
       showColumnGroupChartTooltip={that.showColumnGroupChartTooltip} 
       hideColumnGroupChartTooltip={that.hideColumnGroupChartTooltip}>
       
       </GroupBars> }

       {isStackColumnChart==1 && <StackColumns  primaryYAxis={ primaryYAxis } secondoryYAxis={secondoryYAxis}
       primaryXAxis={primaryXAxis } secondorXAxis={secondorXAxis} chartConfigWithBar={chartConfigWithStackColumn}
       margins={margins}   svgDimensions={svgDimensions} stackLayers={stackLayers} stackBarData={stackBarData}
       isStackLabelsRequired={isStackLabelsRequired} stackLabels={isStackLabelsRequired ? stackLabels :null}
       id={that.props.id}  hideStackBarTooltip={this.hideStackBarTooltip} 
       stackBarKeys={stackBarKeys} isStackColumnChart={isStackColumnChart} showStackBarTooltip={this.showStackBarTooltip}>
       { this.state.stackBarChildComponent && (
          this.renderSTackBarToolTipComponent()
       )
       }
       </StackColumns> } 

       {isStackBarChart==1 && <StackBars  primaryYAxis={ primaryYAxis } secondoryYAxis={secondoryYAxis}
       primaryXAxis={primaryXAxis } secondorXAxis={secondorXAxis} chartConfigWithBar={chartConfigWithStackBar}
       margins={margins}   svgDimensions={svgDimensions} stackLayers={stackLayers} stackBarData={stackBarData}
       isStackLabelsRequired={isStackLabelsRequired} stackLabels={isStackLabelsRequired ? stackLabels :null}
       id={that.props.id}  hideStackBarTooltip={this.hideStackBarTooltip} 
       stackBarKeys={stackBarKeys} isStackBarChart={isStackBarChart} showStackBarTooltip={this.showStackBarTooltip}>
       { this.state.stackBarChildComponent && (
          this.renderSTackBarToolTipComponent()
       )
       }
       </StackBars> } 

       {chartConfig.hasOwnProperty('series') && chartConfig.series.map(function(d,index){
         if(d.type.trim().toLowerCase()=='column' && d.isPartOfGroupColumn!=1 && d.isPartOfGroupBar!=1  && d.isPartOfStackColumn!=1 && d.isPartOfStackBar!=1 && (that.state.disabledSeriesIndex.indexOf(index)==-1)){
          return (<Bars  yAxisScale={d.yAxis==1 ? secondoryYAxis : primaryYAxis } lineStyle={d.lineStyle || {}}
                         xAxisScale={d.xAxis==1 ? secondorXAxis : primaryXAxis } maxBarWidth={d.maxBarWidth}
                         xAxisData={d.xAxis==1 ? xAxisSecondaryCategories : xAxisPrimaryCategories} margins={margins} data={d.data} fillColor={d.fillColor || '#aaa'}
                         svgDimensions={svgDimensions} key={index} dataLabels={d.dataLabels || {}} tooltipStyle={d.tooltipStyle || {}} 
                         tooltipPosition={d.tooltipPosition || "default"} tooltip={d.tooltip} mainDivId={`${that.props.id}`} hoverStyle={d.hoverStyle || {}}
                         id={`${that.props.id}_${index}`} name={d.name || ''} showColumnChartTooltip={that.showColumnChartTooltip} 
                         hideColumnChartTooltip={that.hideColumnChartTooltip} onColumnBarClick={d.onColumnBarClick}
                         isGroupDataHaveNegativeValue={isGroupDataHaveNegativeValue}> closeIconStyle={d.closeIconStyle}
                         { that.state.columnChartChildComponent && (that.state.columnChartOffset.id==that.props.id+"_"+index) &&
                              that.renderColumnChartToolTipComponent()
                          }
                         </Bars>)
         }if(d.type.trim().toLowerCase()=='bar' && d.isPartOfGroupColumn!=1 && d.isPartOfGroupBar!=1  && d.isPartOfStackColumn!=1 && d.isPartOfStackBar!=1 && (that.state.disabledSeriesIndex.indexOf(index)==-1)){
          return (<BarsChart  yAxisScale={d.yAxis==1 ? secondoryYAxis : primaryYAxis }  lineStyle={d.lineStyle || {}}
                         xAxisScale={d.xAxis==1 ? secondorXAxis : primaryXAxis } maxBarWidth={d.maxBarWidth}
                         xAxisData={d.yAxis==1 ? yAxisSecondaryCategories : yAxisPrimaryCategories} margins={margins} data={d.data} fillColor={d.fillColor || '#aaa'}
                         svgDimensions={svgDimensions} key={index} dataLabels={d.dataLabels || {}} tooltipStyle={d.tooltipStyle || {}} 
                         tooltipPosition={d.tooltipPosition || "default"} tooltip={d.tooltip} mainDivId={`${that.props.id}`} hoverStyle={d.hoverStyle || {}}
                         id={`${that.props.id}_${index}`} name={d.name || ''} showColumnChartTooltip={that.showColumnChartTooltip} 
                         hideColumnChartTooltip={that.hideColumnChartTooltip} onColumnBarClick={d.onColumnBarClick} isGroupDataHaveNegativeValue={isGroupDataHaveNegativeValue}> 
                         { that.state.columnChartChildComponent && (that.state.columnChartOffset.id==that.props.id+"_"+index) &&
                              that.renderColumnChartToolTipComponent()
                          }
                         </BarsChart>)
         }else if(d.type.trim().toLowerCase()=='processbar' && d.isPartOfGroupColumn!=1 && d.isPartOfGroupBar!=1  && d.isPartOfStackColumn!=1 && d.isPartOfStackBar!=1 && (that.state.disabledSeriesIndex.indexOf(index)==-1)){
          return (<ProcessBarChart  yAxisScale={d.yAxis==1 ? secondoryYAxis : primaryYAxis }  lineStyle={d.lineStyle || {}}
                      xAxisScale={d.xAxis==1 ? secondorXAxis : primaryXAxis } maxBarWidth={d.maxBarWidth}
                      xAxisData={d.yAxis==1 ? yAxisSecondaryCategories : yAxisPrimaryCategories} margins={margins} data={d.data} fillColor={d.fillColor || '#aaa'}
                      svgDimensions={svgDimensions} key={index} key_index={index} dataLabels={d.dataLabels || {}} tooltipStyle={d.tooltipStyle || {}} 
                      tooltipPosition={d.tooltipPosition || "default"} tooltip={d.tooltip} mainDivId={`${that.props.id}`} hoverStyle={d.hoverStyle || {}}
                      id={`${that.props.id}_${index}`} name={d.name || ''} showColumnChartTooltip={that.showColumnChartTooltip} 
                      hideColumnChartTooltip={that.hideColumnChartTooltip} onColumnBarClick={d.onColumnBarClick}> 
                      { that.state.columnChartChildComponent && (that.state.columnChartOffset.id==that.props.id+"_"+index) &&
                          that.renderColumnChartToolTipComponent()
                      }
                       </ProcessBarChart>)
         }else if((d.type.trim().toLowerCase()=='area' || d.type.trim().toLowerCase()=='areaspline') && (that.state.disabledSeriesIndex.indexOf(index)==-1) ){
          return (<AreaChart  yAxisScale={d.yAxis==1 ? secondoryYAxis : primaryYAxis }  
                         curveStyle={d.curveStyle} id={`${that.props.id}_${index}`} marker={d.marker || {}}
                         mainDivId={`${that.props.id}`} lineStyle={d.lineStyle || {}}
                         tooltipStyle={d.tooltipStyle || {}} globalTooltip={globalTooltip}
                         tooltipPosition={d.tooltipPosition || "default"} tooltip={d.tooltip || false} name={d.name || ''}
                         type={d.type.trim().toLowerCase()} dataLabels={d.dataLabels || {}}
                         xAxisScale={d.xAxis==1 ? secondorXAxis : primaryXAxis }
                         areaChartChildComponent={that.state.areaChartChildComponent} strokeColor={d.strokeColor}
                         xAxisData={d.xAxis==1 ? xAxisSecondaryCategories : xAxisPrimaryCategories} margins={margins} data={d.data} fillColor={d.fillColor || '#aaa'}
                         svgDimensions={svgDimensions} key={index} showAreaChartTooltip={that.showAreaChartTooltip} hideAreaChartTooltip={that.hideAreaChartTooltip}>
                         { that.state.areaChartChildComponent && (that.state.areaChartOffset.id==that.props.id+"_"+index) &&
                              that.renderAreaChartToolTipComponent()
                          }
                         </AreaChart>)
         }else if((d.type.trim().toLowerCase()=='verticalarea' || d.type.trim().toLowerCase()=='verticalareaspline') && (that.state.disabledSeriesIndex.indexOf(index)==-1) ){
          return (<VerticalAreaChart  yAxisScale={d.yAxis==1 ? secondoryYAxis : primaryYAxis }  
                         curveStyle={d.curveStyle} id={`${that.props.id}_${index}`} marker={d.marker || {}}
                         mainDivId={`${that.props.id}`} lineStyle={d.lineStyle || {}}
                         tooltipStyle={d.tooltipStyle || {}} 
                         tooltipPosition={d.tooltipPosition || "default"} tooltip={d.tooltip || false} name={d.name || ''}
                         type={d.type.trim().toLowerCase()} dataLabels={d.dataLabels || {}}
                         xAxisScale={d.xAxis==1 ? secondorXAxis : primaryXAxis }
                         areaChartChildComponent={that.state.areaChartChildComponent}
                         yAxisData={d.yAxis==1 ? yAxisSecondaryCategories : yAxisPrimaryCategories} margins={margins} data={d.data} fillColor={d.fillColor || '#aaa'}
                         svgDimensions={svgDimensions} key={index} showAreaChartTooltip={that.showAreaChartTooltip} hideAreaChartTooltip={that.hideAreaChartTooltip}>
                         { that.state.areaChartChildComponent && (that.state.areaChartOffset.id==that.props.id+"_"+index) &&
                              that.renderAreaChartToolTipComponent()
                          }
                         </VerticalAreaChart>)
         }else if((d.type.trim().toLowerCase()=='line' || d.type.trim().toLowerCase()=='spline') && (that.state.disabledSeriesIndex.indexOf(index)==-1)){
          return (<LineChart  yAxisScale={d.yAxis==1 ? secondoryYAxis : primaryYAxis } gridLineYAxis={gridLineYAxis}
                         curveStyle={d.curveStyle} id={`${that.props.id}_${index}`} type={d.type.trim().toLowerCase()}
                         xAxisScale={d.xAxis==1 ? secondorXAxis : primaryXAxis } dataLabels={d.dataLabels || {}} marker={d.marker || {}}
                         tooltipStyle={d.tooltipStyle || {}}  globalTooltip={globalTooltip}
                         tooltipPosition={d.tooltipPosition || "default"} tooltip={d.tooltip || false} name={d.name || ''} mainDivId={`${that.props.id}`}
                         xAxisData={d.xAxis==1 ? xAxisSecondaryCategories : xAxisPrimaryCategories} margins={margins} data={d.data} lineStyle={d.lineStyle || {}} strokeColor={d.fillColor || '#aaa'}
                         svgDimensions={svgDimensions} lineChartChildComponen={that.state.lineChartChildComponent} key={index} annotationsData={that.props.annotationsData}
                         showLineChartTooltip={that.showLineChartTooltip} hideLineChartTooltip={that.hideLineChartTooltip}  onCircleClick={d.onCircleClick}>
                         { that.state.lineChartChildComponent && (that.state.lineChartOffset.id==that.props.id+"_"+index) &&
                              that.renderLineChartToolTipComponent()
                          }
                         </LineChart>)
         }else if((d.type.trim().toLowerCase()=='verticalline' || d.type.trim().toLowerCase()=='verticalspline') && (that.state.disabledSeriesIndex.indexOf(index)==-1)){
          return (<VerticalLineChart  yAxisScale={d.yAxis==1 ? secondoryYAxis : primaryYAxis } gridLineYAxis={gridLineYAxis}
                         curveStyle={d.curveStyle} id={`${that.props.id}_${index}`} type={d.type.trim().toLowerCase()}
                         xAxisScale={d.xAxis==1 ? secondorXAxis : primaryXAxis } dataLabels={d.dataLabels || {}} marker={d.marker || {}}
                         tooltipStyle={d.tooltipStyle || {}}  globalTooltip={globalTooltip}
                         tooltipPosition={d.tooltipPosition || "default"} tooltip={d.tooltip || false} name={d.name || ''} mainDivId={`${that.props.id}`}
                         yAxisData={d.yAxis==1 ? yAxisSecondaryCategories : yAxisPrimaryCategories} margins={margins} data={d.data} lineStyle={d.lineStyle || {}} strokeColor={d.fillColor || '#aaa'}
                         svgDimensions={svgDimensions} lineChartChildComponen={that.state.lineChartChildComponent} key={index} 
                         showLineChartTooltip={that.showLineChartTooltip} hideLineChartTooltip={that.hideLineChartTooltip}>
                         { that.state.lineChartChildComponent && (that.state.lineChartOffset.id==that.props.id+"_"+index) &&
                              that.renderLineChartToolTipComponent()
                          }
                         </VerticalLineChart>)
         }else if((d.type.trim().toLowerCase()=='bollinger') && (that.state.disabledSeriesIndex.indexOf(index)==-1)){
          return (<BollingerBands  yAxisScale={d.yAxis==1 ? secondoryYAxis : primaryYAxis } gridLineYAxis={gridLineYAxis}
                         curveStyle={d.curveStyle} id={`${that.props.id}_${index}`} type={d.type.trim().toLowerCase()}
                         xAxisScale={d.xAxis==1 ? secondorXAxis : primaryXAxis } dataLabels={d.dataLabels || {}} marker={d.marker || {}}
                         tooltipStyle={d.tooltipStyle || {}}  globalTooltip={globalTooltip}
                         tooltipPosition={d.tooltipPosition || "default"} tooltip={d.tooltip || false} name={d.name || ''} mainDivId={`${that.props.id}`}
                         xAxisData={d.xAxis==1 ? xAxisSecondaryCategories : xAxisPrimaryCategories} margins={margins} data={d.data} lineStyle={d.lineStyle || {}} strokeColor={d.fillColor || '#aaa'} path={d.path || undefined}
                         svgDimensions={svgDimensions} lineChartChildComponen={that.state.lineChartChildComponent} key={index} 
                         showLineChartTooltip={that.showLineChartTooltip} hideLineChartTooltip={that.hideLineChartTooltip}>
                         { that.state.lineChartChildComponent && (that.state.lineChartOffset.id==that.props.id+"_"+index) &&
                              that.renderLineChartToolTipComponent()
                          }
                         </BollingerBands>)
         }
       })}

      

        {globalTooltip!=null && <g className={that.props.id+"_globalTooltipG"} transform={"translate(0,"+margins.top+")"}>
          {xAxisPrimaryCategories.map(function(xAxisData,index){
            xAxisData=(typeof(xAxisData)=='object' && xAxisData!=null)? xAxisData.data : xAxisData;
            var globalTooltipPosition=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.position || 'middle') : 'middle';
            
            var globalTooltipCategory=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.category || '' ) : '';
            

            var globalTooltipMouseOverCallback=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.onMouseOver || (()=>{}) ) : (()=>{});
            var globalTooltipOnClickCallback=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.onClick || (()=>{}) ) : (()=>{});
            var globalTooltipMouseOutCallback=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.onMouseOut || (()=>{}) ) : (()=>{});
            var widthOfWrapperRect=xAxisPrimaryScaleType=='scaleband'?
            primaryXAxis.scale.bandwidth()+(primaryXAxis.scale.bandwidth() * (primaryXAxis.scale.padding()+primaryXAxis.scale.paddingOuter())) :
            primaryXAxis.scale.step();
            var xPosition=xAxisPrimaryScaleType=='scaleband'?
            primaryXAxis.scale(xAxisData)-((primaryXAxis.scale.bandwidth() * (primaryXAxis.scale.padding()+primaryXAxis.scale.paddingOuter()))/2) :
            primaryXAxis.scale(xAxisData)-((primaryXAxis.scale.bandwidth() * (primaryXAxis.scale.padding()))/2);
            var rectxPosition=xAxisPrimaryScaleType=='scaleband'?
            primaryXAxis.scale(xAxisData)-((primaryXAxis.scale.bandwidth() * (primaryXAxis.scale.padding()+primaryXAxis.scale.paddingOuter()))/2) :
            (primaryXAxis.scale(xAxisData)-((primaryXAxis.scale.bandwidth() * (primaryXAxis.scale.padding()))/2))-(widthOfWrapperRect/2);
            if(index==xAxisPrimaryCategories.length-1 && gridLineYAxis!=null){
              widthOfWrapperRect=widthOfWrapperRect/2;
            }
            const mainLabelFormat=globalTooltip.mainLabelFormat!=null? globalTooltip.mainLabelFormat :null;
            var globalData={
                xAxisTooltipsLabel:typeof(mainLabelFormat) == 'function' ? customFormat(xAxisData,mainLabelFormat, index) : xAxisData,
                dataIndex:index,
                x:primaryXAxis.scale(xAxisData)+(primaryXAxis.scale.bandwidth()/2),
                y:(globalTooltipPosition=='top') ? margins.top :((svgDimensions.height-margins.bottom)/2)
               };
             return <g key={"globalG_"+index}><rect key={"globalRect_"+index} data={index} style={{fill:"transparent"}}
              x={rectxPosition} 
             width={widthOfWrapperRect} 
             height={(svgDimensions.height-margins.top-margins.bottom)}
             onClick={(e,index)=>{
              var myTarget = e.target;
              clearTimeout(globalTooltipOnClickCallbackTimer);
              globalTooltipOnClickCallbackTimer = setTimeout(()=>{
                globalTooltipOnClickCallback(globalTooltipDataForCallback,d3.select(myTarget).attr("data"),xAxisData);
                // console.log("globalTooltipMouseOutCallback")
              }, 250);
             }}
             onMouseEnter={(e,index)=>{
               d3.selectAll("circle[cx='"+(primaryXAxis.scale(xAxisData)+(primaryXAxis.scale.bandwidth()/2))+"']").transition().style("stroke-opacity",0.5);
              //  d3.select("."+"globalTooltipsLine_"+that.props.id).transition();
              d3.select("."+"globalTooltipsLine_"+that.props.id).transition().duration(that.props.duration)
              .attr("x1",primaryXAxis.scale(xAxisData)+(primaryXAxis.scale.bandwidth()/2))
              .attr("x2",primaryXAxis.scale(xAxisData)+(primaryXAxis.scale.bandwidth()/2));
              d3.select("."+"globalTooltipsLine_"+that.props.id).style("stroke-opacity",1);
              var myTarget = e.target;
              clearTimeout(globalTooltipMouseOverCallbackTimer);
              globalTooltipMouseOverCallbackTimer = setTimeout(()=>{
                globalTooltipMouseOverCallback(globalTooltipDataForCallback,d3.select(myTarget).attr("data"),xAxisData,containerId);
                // console.log("globalTooltipMouseOutCallback")
              }, 250);
              showDetail({id:`${that.props.id}`,margins:margins},globalData,e,globalTooltip,globalTooltipData,{}, that.props.duration);
             }}
             onMouseOut={(e)=>{
              d3.selectAll("circle[cx='"+(primaryXAxis.scale(xAxisData)+(primaryXAxis.scale.bandwidth()/2))+"']").style("stroke-opacity",0);
              d3.select("."+"globalTooltipsLine_"+that.props.id).style("stroke-opacity",0);
              hideDetail();
              clearTimeout(globalTooltipMouseOutCallbackTimer);
              globalTooltipMouseOutCallbackTimer = setTimeout(()=>{
                globalTooltipMouseOutCallback();
                // console.log("globalTooltipMouseOutCallback")
              }, 250);
             }}></rect>
            
             </g>
          })}
          <line x1="0" x2="0" y1={0} y2={svgDimensions.height-margins.bottom-margins.top} 
          style={$.extend({stroke:"#ccc",pointerEvents:"none",strokeOpacity:0},false,globalTooltipLineStyle)  || {stroke:"#ccc",pointerEvents:"none",strokeOpacity:0}} 
          className={"globalTooltipsLine_"+that.props.id}></line>

        </g>}

      </g>
    );
  }
}
export function _searchAll(searchString, data, searchKeys) {
  if (Object.prototype.toString.call(searchString) !== "[object Array]") {
    searchString = [searchString];
  }
  return searchString.every(function(_searchString) {
    return _search(_searchString, data, searchKeys,0);
  });
}

export function _search(searchString, data, searchKeys, depth) {
  var typeOfData = typeof data;
  switch (typeOfData) {
    case "object":
      {
        try {
          var keys = Object.keys(data).filter(function(d) {
            return !searchKeys[depth] || searchKeys[depth].length == 0 || searchKeys[depth].indexOf(d) > -1;
          });
          var found = false;
          for (var i = 0; i < keys.length && found == false; i++) {
            found = _search(searchString, data[keys[i]], searchKeys, depth + 1);
          }
          return found;
        } catch (e) {
          //nothing to handle
          return false;
        }
        break;
      }
    case "number":
      {
        data = data.toString();
      }
    case "string":
      {
        if (data.search(new RegExp(searchString, "i")) === -1) {
          return false;
        } else {
          return true;
        }
        break;
      }
    default:
      {
        return false;
      }
  }
  return false;
}

function mountScrollDownEvent(){
  $(window).bind("scroll",function (event) {
    hideDetail();
  });
}

export function showDetail(props, globalData, mouseEvent,globalTooltip,globalTooltipData,tooltipStyle,duration) {
  var globalTooltipPosition=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.position || 'middle') : 'middle';
  var defaultValueFormat=function(d){
      return d;
    };
  var labelFontSize =tooltipStyle.labelFontSize ||  "12px";
  var labelFontColor =tooltipStyle.labelFontColor ||  "black";
  var labelFontFamily = tooltipStyle.labelFontFamily ||  "";
  var valueFontSize =tooltipStyle.valueFontSize ||  "12px";
  var valueFontColor =tooltipStyle.valueFontColor ||  "black";
  var valueFontFamily =tooltipStyle.valueFontFamily ||  "";
  var valueFormat=tooltipStyle.valueFormat ;
  var valuePrefix=tooltipStyle.valuePrefix ;
  var valuePostfix=tooltipStyle.valuePostfix ;
  var valueFormatter='';
  if(globalTooltip!=null){
    var xAxisTooltipsLabel=globalData["xAxisTooltipsLabel"];
    var dataIndex=globalData["dataIndex"];
    var content = `<tr>
          <td colspan="2" class="value"  style="text-align: center;letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
            xAxisTooltipsLabel
      }</td></tr>`;
    var tooltipsContents = Object.keys(globalTooltipData);
    var preparedData=[];
    var tempObj={};
    tooltipsContents.map(function(data) {
       valueFormat=tooltipStyle.valueFormat || (globalTooltipData[data]["dataLabels"]["format"] || defaultValueFormat);
       valuePrefix=tooltipStyle.valuePrefix || (globalTooltipData[data]["dataLabels"]["prefix"] || ""); 
       valuePostfix=tooltipStyle.valuePostfix || (globalTooltipData[data]["dataLabels"]["postfix"] || ""); 
       valueFormatter=tooltipStyle.valueFormatter || (globalTooltipData[data]["dataLabels"]["formatter"] || ""); 
        content =
          content +
          `<tr><td class="key" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${labelFontSize};font-family:${labelFontFamily};color:${labelFontColor}">${data} </td>
              <td class="value" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
                (typeof(valueFormatter)=='function') ?(valueFormatter(globalTooltipData[data]["data"][dataIndex])) :( valuePrefix+""+customFormat( globalTooltipData[data]["data"][dataIndex],valueFormat)+""+valuePostfix)
          }</td></tr>`;
      });
      tempObj["content"] = content;
      tempObj["x"] = globalData.x;//d3.event.x;
      tempObj["y"] =globalData.y;//mouseEvent.clientY;// d3.event.y;
      tempObj["mainDivId"] = props.id;
      tempObj["marginLeft"] = props.margins.left;
      tempObj["marginTop"] = props.margins.top;
      if(tooltipsContents.length>0)
        preparedData.push(tempObj);
      tooltip.showTooltip(preparedData, d3.event, "tooltip_map",false,globalTooltip,duration);//,isMouseMove,isGlobalTooltip
  }
  
}

export function hideDetail(d) {
  tooltip.hideTooltip();
}
